import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {slideInRightOnEnterAnimation, slideOutLeftOnLeaveAnimation} from 'angular-animations';
import {Subscription} from 'rxjs';
import {SYSTEM_NAME} from 'src/app/shared/constants/constants';
import {Location} from "@angular/common";
import {ForgetPassswordService} from "../../services/forget-passsword.service";
import {passwordPolicyValidator} from "../../shared/validators/input-validators";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  animations: [
    slideOutLeftOnLeaveAnimation({duration: 400, animateChildren: "after", translate: "100px"}),
    slideInRightOnEnterAnimation({duration: 400, animateChildren: "after", translate: "100px"})
  ]
})
export class ResetPasswordComponent implements OnInit {
  currentYear: any;
  loading = false;
  subscription: Subscription = new Subscription();
  resetPasswordForm: FormGroup;
  userType: string;
  title: string;
  isLogin = true;
  showPassword: boolean;
  sessionExpired: boolean;
  message = "Welcome again to";


  hidePassword = true;
  hideNewPassword = true;
  hideConfirmPassword = true;
  token: string
  phoneNo: string
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private forgotPasswordService: ForgetPassswordService
  ) {
    this.token =  this.activatedRoute.snapshot.paramMap.get('token')
    this.phoneNo = this.activatedRoute.snapshot.paramMap.get('number')
  }

  ngOnInit(): void {

    this.title = SYSTEM_NAME;
    this.resetPasswordForm = this.fb.group({
      password: ['',  [Validators.required, passwordPolicyValidator()]],
      confirmPassword: ['',  [Validators.required, passwordPolicyValidator()]],
    });
  }
  //
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  submitForm(formData) {
    if(formData.password === formData.confirmPassword){
      if(this.token){
        this.forgotPasswordService.emailResetPassword(this.token, formData.password).subscribe({
          next: () => {
            console.log('Password reset request successful');
            this.router.navigate([`/login`]);
          },
          error: (err) => {
            console.error('Password reset request failed', err);
            // this.notificationService.errorMessage('Failed to reset password');
          },
        });
      } else if(this.phoneNo){
        this.forgotPasswordService.citizenActivateMutation({
          password: formData.password,
          phoneNumber: this.phoneNo,
        }).subscribe({
          next: () => {
            console.log('Password reset request successful');
            this.router.navigate([`/login`]);
          },
          error: (err) => {
            console.error('Password reset request failed', err);
            // this.notificationService.errorMessage('Failed to reset password');
          },
        });
      }
    }
  }

  goBack() {
    this.location.back();
  }

  toggleLogin() {
    this.isLogin = !this.isLogin;
  }
}


